import { Fragment, useEffect, useState } from "react";
import { Button, useMediaQuery } from "@mui/material";
import { responsiveAppBarStyles } from "../ResponsiveNavbar/styles";
import { CustomTextField } from "../TracksPageComponents/styles";
import { ExploreTracksSearchBarProps } from "./types";

export const ExploreTracksSearchBar: React.FC<ExploreTracksSearchBarProps> = ({
  setFeaturedTracks,
  setPublicTracks,
  setPage,
  queryValue,
  setQueryValue,
  setIsFeaturedTracksLoaded,
  setIsScrollEnabled,
}) => {
  const [query, setQuery] = useState<string>("");
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const isMediumScreen = useMediaQuery("(max-width: 1536px)");

  const handleQueryChange = (e: string) => {
    setQuery(e);
    if (e === "") {
      setQueryValue("");
      setIsFeaturedTracksLoaded(false);
      setIsScrollEnabled(true);
      setPage(0);
      setFeaturedTracks([]);
      setPublicTracks([]);
    }
  };

  useEffect(() => {
    if (queryValue === "") {
      setQuery("");
    }
  }, [queryValue]);

  const handleEnterPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" && query !== "") {
      setIsFeaturedTracksLoaded(false);
      setIsScrollEnabled(true);
      setPage(0);
      setFeaturedTracks([]);
      setPublicTracks([]);
      setQueryValue(query);
    }
  };

  return (
    <>
      <CustomTextField
        sx={{ width: isSmallScreen ? "100%" : "320px" }}
        value={query}
        size={isSmallScreen ? "small" : "medium"}
        placeholder="Search tracks"
        onKeyPress={handleEnterPress}
        onChange={(e) => {
          handleQueryChange(e.target.value);
        }}
        InputProps={{
          endAdornment: (
            <Fragment>
              <Button
                onClick={() => {
                  if (query !== "") {
                    setPage(0);
                    setFeaturedTracks([]);
                    setPublicTracks([]);
                    setIsFeaturedTracksLoaded(false);
                    setIsScrollEnabled(true);
                    setQueryValue(query);
                  }
                }}
                sx={
                  isMediumScreen
                    ? {
                        ...responsiveAppBarStyles.signupButton,
                        fontSize: "12px",
                        height: "30px",
                      }
                    : responsiveAppBarStyles.signupButton
                }
              >
                Search
              </Button>
            </Fragment>
          ),
        }}
      />
    </>
  );
};
